<i18n src="./translations"></i18n>
<!-- OE NR -->
<template>
  <ExpandableTableSection
    :trigger="trigger"
    :table="table"
    :preview="{ limit: oeNumbersPreviewCount }"
    :expanded="expanded"
    @tableLoaded="onTableLoaded"
  >
    <template #oeNumber="{ entity }">
      <MaskedLink
        :redirect-to="oeSearchUrl(entity.oeNumber)"
        :text="entity.oeNumber"
        class="oe-link"
        :aria-label="
          $t('pdp-tab-oe-numbers.oe-number-aria', {
            '%oeNumber%': entity.oeNumber,
          })
        "
        data-testid="oe-number-link"
      />
    </template>
  </ExpandableTableSection>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';
import MaskedLink from 'Components/01-atoms/masked-link/MaskedLink';
import ExpandableTableSection from 'Components/02-molecules/expandable-table-section/ExpandableTableSection';

export default {
  name: 'PdpTabOeNumbers',
  components: { ExpandableTableSection, MaskedLink },
  mixins: [globalMixin],
  props: {
    productId: {
      type: String,
      required: true,
    },
    hasOeNumbers: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: Boolean,
      default: false,
    },
    plainTabBase: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      oeNumbersCount: null,
      oeNumbersPreviewCount: 4,
    };
  },
  computed: {
    ajaxUrl() {
      if (!this.productId || !this.hasOeNumbers) return '';
      const endpoint = this.frontFacingPath('search.ajax.product.oe_numbers');
      return endpoint.replace('{productId}', this.productId);
    },
    trigger() {
      return {
        show: this.oeNumbersCount > this.oeNumbersPreviewCount,
        title: this.$t('pdp-tab-oe-numbers.show-all', {
          '%count%': this.oeNumbersCount,
        }),
        modifiers: ['secondary', 'slim'],
      };
    },
    expanded() {
      return {
        enabled: Boolean(this.ajaxUrl),
        title: this.$t('pdp-tab-oe-numbers.headline'),
        limit: 10,
        note: this.$t('pdp-tab-oe-numbers.dialog-note'),
      };
    },
    table() {
      return {
        isAjax: true,
        url: this.ajaxUrl,
        tableKey: 'oeNumbers',
        loadMoreLabel: this.$t('pdp-tab-oe-numbers.load_more'),
        showHeaders: false,
        hasBorder: false,
      };
    },
  },
  methods: {
    onTableLoaded(payload) {
      if (payload?.tableKey !== 'oeNumbers') return;
      if (!Number.isFinite(payload?.count)) return;
      this.oeNumbersCount = payload.count;
    },
    oeSearchUrl(oeNumber) {
      return (
        this.frontFacingPath('search.search_bar.search') +
        '?search=' +
        oeNumber.replace(/\s/g, '+') +
        '#oens'
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';

.oe-link {
  display: block;
  color: var(--color-nero);
  text-decoration: underline;
  text-align: right;
}
</style>
